import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsPageNavigation.module.scss";
import {SongsPageNavigationItem} from "../songs-navigation-item/SongsPageNavigationItem";

export const SongsPageNavigation: VoidFunctionComponent = () => {
  return <nav className={s.container}>
    <SongsPageNavigationItem resultsPageLink={`home`} title={"Home"} />
    <SongsPageNavigationItem resultsPageLink={`browse`} title={"Browse"} />
    <SongsPageNavigationItem resultsPageLink={`library`} title={"Library"} />
  </nav>;
}
